import { render, staticRenderFns } from "./TeamContractAudit.vue?vue&type=template&id=2a21b834&scoped=true"
import script from "./TeamContractAudit.vue?vue&type=script&lang=js"
export * from "./TeamContractAudit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a21b834",
  null
  
)

export default component.exports